<template>
  <div>
    <fixed-header id="sticky-header">
      <div class="row form-header">
        <div class="col-sm-4 col-xl-4 m-auto">
          <router-link 
            class="h6"
            tag="a"
            to="/application"
          >
            <i class="uil-arrow-left"></i> APPLICATION
          </router-link>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="mt-4 mt-md-0">
            <!-- <a href="javascript:void(0)"
              @click="addAttachment" class="btn btn-sm mx-1"><feather type="file-plus" class="icon-md"></feather></a> -->

           <!--  <input 
              type='file' 
              id="attachmentUpload" 
              hidden=true
              @change="addAttachment" />
            <label for="attachmentUpload" class="btn btn-sm m-0 mx-1 text-muted"><feather type="file-plus" class="icon-md"></feather></label> -->
            <button
              class="btn btn-primary btn-sm"
              v-if="!model.has_consent"
              @click="resend"
            ><i class="uil-envelope-alt"></i> Resend Consent</button>
          </div>
        </div>
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-lg-3">
          <div class="card">
            <div class="card-body pb-0">
              <div class="media">
                <img
                  ref="imageAvatar"
                  src="@assets/images/users/avatar-7.jpg"
                  class="mr-3 avatar-xxl rounded-circle"
                  alt="avatar"
                />
                <div class="media-body">
                  <h5 class="mt-3 mb-0">{{ model.full_name }} <span class="small" v-if="model.reference_no">#{{ model.reference_no}}</span></h5>
                  <h6 class="font-weight-normal mt-1 mb-4 text-muted">
                    {{ model.present_work }}
                  </h6>
                  <!-- <button type="button" class="btn btn-white btn-sm btn-block btn-disabled" disabled>
                    View Resume
                  </button> -->
                </div>
              </div>

              <div class="text-center mt-3">
                <div class="mt-4 pt-3 border-top text-left">

                  <ul class="list-unstyled events mb-0 font-1 text-muted">
                    <li class="my-2" v-if="model.gender"><i class="mr-2 uil-user"></i> {{model.gender | capitalize}}</li>
                    <li class="my-2" v-if="model.date_of_birth"><i class="mr-2 uil-gift"></i> {{ model.date_of_birth | date}}</li>
                    <li class="my-2" v-if="model.country"><i class="mr-2 uil-location-point"></i> {{model.city}} {{model.country}}</li>
                    <li class="my-2" v-if="model.contact_no"><i class="mr-2 uil-phone"></i> {{ model.contact_no }}</li>
                    <li class="my-2" v-if="model.email"><i class="mr-2 uil-envelope"></i> {{model.email}}</li>
                    <li class="my-2" v-if="model.skype"><i class="mr-2 uil-skype"></i> king_munoz_12</li>
                    <li class="my-2" v-if="model.website"><i class="mr-2 uil-globe"></i> wwww.rickyignacio.com</li>
                  </ul>

                  <div class="social-feeds">
                    <a href="" v-if="model.facebook"><i class="uil-facebook"></i></a>
                    <a href="" v-if="model.twitter"><i class="uil-twitter text-info"></i></a>
                    <a href="" v-if="model.dribble"><i class="uil-dribbble text-danger"></i></a>
                    <a href="" v-if="model.behance"><i class="uil-behance"></i></a>
                  </div>
                </div>

                  <div class="mt-3 pt-2 border-top text-left">
                    <h4 class="mb-3 font-size-15">{{$t('application.form.skills')}}</h4>
                    <div class="text-center my-4"
                      v-if="!model.skills.length"
                    >{{$t('application.form.empty_skills')}}.</div>
                    <VuePerfectScrollbar style="max-height: 140px">
                    <label class="badge badge-soft-secondary mr-1"
                      v-for="item in model.skills"
                      :key="item.id"
                    >{{ item.name }}</label>
                    </VuePerfectScrollbar>

                  </div>

                <div class="my-3 pt-2 border-top text-left">
                  <h4 class="mb-3 font-size-15">{{$t('application.form.attachments')}}</h4>
                  <div class="text-center my-4"
                      v-if="!model.attachments.length"
                    >{{$t('application.form.empty_attachments')}}.</div>

                  <VuePerfectScrollbar style="max-height: 300px">
 
                    <div class="card mb-2 shadow-none border"
                      v-for="(item, idx) in model.attachments"
                      :key="`item-${item._id}`"
                    >
                      <div class="p-1 px-2">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <img src="@assets/images/projects/project-1.jpg" class="avatar-sm rounded" alt="file-image">
                            </div>
                            <div class="col pl-0" style="white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;">
                                <a href="javascript:void(0);" class="text-muted font-weight-bold">{{ item.originalname }}</a>
                                <p class="mb-0">{{ item.size.$numberDecimal | bytes}}</p>
                            </div>
                            <div class="col-auto">
                              <a
                                @click="onDownloadAttachment(item._id, idx)"
                                data-toggle="tooltip" 
                                data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                data-original-title="Download">
                                  <i class="uil uil-cloud-download font-size-14"></i>
                              </a>
                            </div>
                        </div>
                      </div>
                    </div>
                  </VuePerfectScrollbar>
                  
                </div>
              </div>
            </div>
          </div>
      </div>

      <div class="col-lg-4">

        <!-- <div class="card">
          <div class="card-body">
            <h5 class="card-title pb-2 border-bottom">{{$t('application.form.tags')}}</h5>
              <VuePerfectScrollbar style="max-height: 100px">
                <a class="btn badge badge-soft-danger badge-pill text-white ml-2 mb-2"
                  @click="showTag = true"
                ><i class="uil-plus"></i> Add tag</a>

                <span class="btn badge badge-primary badge-pill text-white ml-2 mb-2 tag-wrapper"
                  v-for="(item, index) in model.tags"
                  :key="`item-${item.uiid}`"
                >
                  <i class="uil-times mr-2" @click="onDeleteTag(index, item)"></i>
                  <span class="capsule">{{item.name}}</span>
                </span>
              </VuePerfectScrollbar>

          </div>
        </div> -->

        <div class="card">
          <div class="card-body">
            <h5 class="card-title pb-2 border-bottom">
              {{$t('application.form.working_experience')}}
              <!-- <a href="#"
                @click="show = true"
                class="btn btn-primary btn-sm btn-rounded float-right">
                <i class="uil-plus"></i>
              </a> -->
            </h5>

            <div class="text-center"
              v-if="!model.work_experiences.length"
            >{{$t('application.form.empty_working_experience')}}.</div>

            <VuePerfectScrollbar style="max-height: 300px">
              <div class="media mt-3 p-1 border-bottom"
                v-for="item in model.work_experiences"
                :key="`item-${item.uiid}`"
              >
                <div class="media-body">
                  <h5 class="mt-0 mb-0 font-size-14">
                    <span class="float-right text-muted font-size-12">{{ item.company }}</span>
                    {{ item.position }}
                  </h5>
                  <p class="text-muted my-1">
                    <span class="float-right text-muted font-size-12"> {{ item.loc_country_code }} </span>
                    {{ item.start_month | capitalize  }} {{ item.start_year }} - {{ (item.present == true ? "Present" : item.end_month) | capitalize }} {{ item.present == true ? "" : item.end_year }}
                  </p>
                </div>
              </div>
            </VuePerfectScrollbar>

          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title pb-2 border-bottom">
              {{$t('application.form.educational_background')}}
              <!-- <a 
                href="#"
                @click="showEd = true"
                class="btn btn-primary btn-sm btn-rounded float-right">
                <i class="uil-plus"></i>
              </a> -->
            </h5>
          <div 
            class="text-center"
            v-if="!model.education_background.length"
            >{{$t('application.form.educational_background')}}.</div>


            <VuePerfectScrollbar style="max-height: 300px">
              <div class="media mt-3 p-1 border-bottom"
                v-for="item in model.education_background"
                :key="`item-${item.uiid}`"
              >
                <div class="media-body">
                  <h5 class="mt-0 mb-0 font-size-14">
                    <span class="float-right text-muted font-size-12">{{ item.start_year }} - {{ item.end_year }}</span>
                    {{ item.school_type | capitalize}}
                  </h5>
                  {{ item.degree  }}
                  <p class="mb-1">{{ item.school  }}</p>
                </div>
              </div>
            </VuePerfectScrollbar>

          </div>
        </div>
      </div>

      <!-- <div class="col-lg-5">
        <div class="card">
          <div class="card-body">

            <h5 class="card-title pb-2 border-bottom">Activities</h5>
            
            <VuePerfectScrollbar style="max-height: 500px">
              <div 
                class="text-center"
                v-if="!model.activities.length"
                >No activies found.</div>

                <div class="custom-timeline pl-4" 
                  v-for="item in model.activities"
                  :key="item._id"
                >
                  <ul class="list-unstyled events">
                    <li class="event-list" >
                      <div v-if="item.type != 'application'">
                        <div class="event-date text-muted pt-2">
                          <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                        </div>
                        <div class="media">
                          <div class="media-body">
                            
                            <div class="card">
                              <div class="card-body mt-3">
                                <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                <p class="text-muted">
                                  {{ item.description }}
                                </p>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div v-if="item.type == 'application'">
                        <div class="event-date text-muted pt-2">
                          <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                        </div>
                        <div class="media">
                          <div class="media-body">
                            
                            <div class="card">
                              <div class="card-body mt-3">
                                <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                <p class="text-muted">
                                  {{ item.description }}
                                </p>
                                <div>Position: {{ item.job_id.title }}</div>
                                <div>Company: {{ item.job_id.company_id.name }}</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

            </VuePerfectScrollbar>
            
          </div>
        </div>
      </div> -->
    </div>

    <b-modal 
      v-model="showTag" 
      size="sm"
      centered
      ref="skill"
      :title="(tag.uiid ? 'Edit' : 'Add') + ' Tag'" 
      title-class="font-18">
        <TextField 
          placeholder="Enter tag"
          v-model="tag.name"
        />
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showTag = false">Close</b-button>
        <b-button variant="primary" @click="onAddTag">{{ ( tag.uiid ? 'Update' : 'Add') + ' Tag' }}</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import FixedHeader from 'vue-fixed-header'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment/moment'
import TextField from '@components/form/textfield.vue'

export default {
  mixins: [FormMixin],
  components:{FixedHeader, VuePerfectScrollbar, TextField},
  data(){
    return {
      model:{
        full_name: '',
        email: '',
        contact_no: '',
        work_experiences:[],
        education_background:[],
        skills:[],
        tags:[],
        attachments:[],
        activities:[],
        applications:[],
        job_id:{
          title:'',
          company_id:{
            name:''
          }
        }
      },
      tag:{},
      showTag:false,
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
    }
  },
  /* computed: {
    present_work: function() {
      let position
      for(var key in this.model.work_experiences){
        var work = this.model.work_experiences[key]
        if(work.present == true){
          position = work.position
        }
      }
      return position
    },
  }, */
  beforeMount(){
    window.addEventListener('resize', this.handleResize)
    this.fetchData()
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('prospect', ['uploadAttachment', 'downloadAttachment', 'deleteAttachment', 'createTag', 'removeTag']),
    ...mapActions('application', ['getApplication', 'resendConsent']),
    resend(){
      this.$bvModal.msgBoxConfirm('Are you sure you want to resend the consent form?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'RESEND',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()
          this.resendConsent({application:this.model.application || this.model.application_id}).then(()=>{
            this.$bvToast.toast(`Consent form was re-sent to applicant.`, {
              title: 'Notification',
              variant:'success'
            })
						this.toggleLoading()
          })
        }
      })
      
    },
    onAddTag(){
      
      if(this.tag.name){
        delete this.tag._idx

        this.tag.prospect_id = this.$route.query.id
        this.createTag(this.tag).then(res => {
          this.model.tags.push(res.data)
        })

        this.tag = {}
        this.showTag = false
      }else{
        this.showTag = true
      }

    },
    onDeleteTag(idx, item){

      this.removeTag(item).then(res => {
        if(res.data.ok == 1){
          this.model.tags.splice(idx, 1)
          this.tag = {}
        }else{
          alert('Please try again')
        }
      })
    },
    async fetchData(){
      let params = {}

      if(this.$route.query.prospect){
        params['prospect'] = this.$route.query.prospect
      }else{
        params['id'] = this.$route.query.id
      }

      await this.getApplication(params).then(data => {
        this.model = data.data

        if(this.model.avatar_path){
          this.$refs['imageAvatar'].src = this.model.avatar_path
        }
      })
    },
    onDownloadAttachment(uiid){
      /* this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data){  
            this.$nextTick().then(() => {
              this.$refs.downloader.downloadFile(res.config.baseURL.replace('api', '') +  res.data.path)
            })
          }
        }
        
      }) */
      this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data){
            const url = res.data.baseUrl + '/' +  res.data.attachment.path
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', res.data.originalname) //or any other extension
            link.setAttribute('target', '_blank') //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
            /* this.$nextTick().then(() => {
              this.$refs.downloader.downloadFile(res.config.baseURL.replace('api', '') +  res.data.path)
            }) */
          }
        }
        
      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/administration/user')
    }
  },
  filters: {
    date: function (value, format) {
      return moment(value).format(format || 'YYYY-MM-DD')
    },
    custom_date: function (value) {
      return moment(value).format('Mo MMMM YYYY')
    }
  }
}
</script>


<style>
  .ps__rail-y{
    z-index:1
  }
  .ps__rail-x{
    z-index:1
  }
</style>